export * from './confirmed-tickets.component'